import { gql } from '@apollo/client';

export const PUSH_HISTORY = gql`
  query getPush($first: UnsignedInt!, $where: PushFilterInput) {
    pushes(first: $first, where: $where) {
      id
      title
      body
      targetDevice
      article {
        id
      }
      userId
      user {
        id
        name
      }
      scheduledAt
      sentAt
      isCancelled
      segments(first: 100) {
        segment {
          title
        }
      }
    }
  }
`;
